import AdvanceSetting from '@/components/shared/AdvanceSetting/AdvanceSetting.vue';
import dayjs from 'dayjs';
import { createNamespacedHelpers } from 'vuex';
const globalMapper = createNamespacedHelpers('global');

const DATE_START = 0;
const DATE_END = 1;

const advancedSettingMapper = createNamespacedHelpers('global/advancedSetting');
const authMapper = createNamespacedHelpers('global/auth');

export default {
	components: {
		AdvanceSetting,
	},

	computed: {
		...advancedSettingMapper.mapState(['advancedSetting', 'advancedSettingId']),
		...authMapper.mapState(['userInfo']),
		advancedSettingDetector() {
			return this.advancedSetting?.detector;
		},
	},

	async mounted() {
		// get current connected cameras
		await this.getCurrentConnectedCameras();
	},

	methods: {
		...advancedSettingMapper.mapActions(['saveAdvanceSetting', 'editAdvanceSetting', 'getCurrentConnectedCameras']),

		/**
		 * Save settings
		 */
		async onSave() {
			// loop for every setting
			let body = {};
			for (const screenSettings in this.advancedSetting) {
				this.advancedSetting[screenSettings].map((setting) => {
					body[setting.key] = setting.settingContent;

					// Convert detector_default_date to timestamp
					if (setting.key === 'detector_default_date') {
						let temp = structuredClone(body[setting.key]);
						temp.map((date) => dayjs(date).unix());
						body[setting.key] = temp.map((date) => dayjs(date).unix());
					}
				});
			}

			if (this.advancedSettingId) {
				await this.editAdvanceSetting({ body, userId: this.userInfo?.id });
				return;
			}
			await this.saveAdvanceSetting({ body, userId: this.userInfo?.id });
		},

		onClickToggle(id, typeSetting) {
			this.advancedSetting[typeSetting][id].settingContent =
				!this.advancedSetting[typeSetting][id].settingContent;
		},

		onClickSettingDate(id, rangeDate, typeSetting) {
			const dateStart = dayjs(`${rangeDate[DATE_START]}`).format('YYYY/MM/DD');
			const dateEnd = dayjs(`${rangeDate[DATE_END]}`).format('YYYY/MM/DD');

			const dayStartRecent = dayjs(dateStart)
				.set('hour', 0)
				.set('minute', 0)
				.set('second', 0)
				.format('YYYY/MM/DD HH:mm:ss');

			const dayEndRecent = dayjs(dateEnd)
				.set('hour', 23)
				.set('minute', 59)
				.set('second', 59)
				.format('YYYY/MM/DD HH:mm:ss');

			this.advancedSetting[typeSetting][id].settingContent = [
				dayStartRecent,
				dayEndRecent,
			];
		},
		onClickSelectCamera(id, selectedCamera, typeSetting) { 
			this.advancedSetting[typeSetting][id].settingContent = selectedCamera;
		}
	},
};
